import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

const MOCKDATA: RealEstateDataPageComponentData = {
    items: [{
        paragraphs: ["¡Hola!", "Mi nombre es"]
    }],
    nameSignarutre: "Luis Bustos",
    imgSignarutre: "https://cdn.pixabay.com/photo/2016/02/11/19/03/michael-jackson-1194286_1280.png",
    paragraph: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum, excepturi. Facere fugiat commodi suscipit repellendus, esse labore eveniet aspernatur accusantium iste odio consectetur.",
    image: "https://cdn.pixabay.com/photo/2017/05/19/12/38/entrepreneur-2326419_1280.jpg",
}

const SummaryBrand = (props: RealEstateDataPageComponentData) => {

    const { isDemo } = props
    const { items, nameSignarutre, imgSignarutre, paragraph, image } = isDemo ? MOCKDATA : props;

    return (
        <section id="summary-brand">
            <Container fluid>
                <Row>
                    <Col xs={12} lg={4} className="text-col-container d-flex flex-column">
                        <h2 className="section-title py-5">
                            { items![0].paragraphs![0] ? 
                                <><span>{ items![0].paragraphs![0] }</span>
                                    <br /></> : null }
                            { items![0].paragraphs![1] ? 
                                <><span>{items![0].paragraphs![1]}</span>
                                    <br /></> : null }
                            <span className="name-signature">{nameSignarutre}</span>
                        </h2>
                        <p className="text pb-5">{paragraph}</p>
                        <img src={imgSignarutre} alt={nameSignarutre} className="img-signature" />
                    </Col>
                    <Col xs={12} lg={8} className="img-col-container d-flex justify-content-center">
                        <img src={image} alt={nameSignarutre} className="img-person mt-5 mt-lg-0"/>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default SummaryBrand
